import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "Pages/Home";
import Login from "Pages/Login";
import SingleReport from "Pages/Home/Reports/singleReport";

import Middleware from "./Middleware";

const ROUTES = [
  {
    path: "/",
    element: <Middleware />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/login", element: <Login /> },
      { path: "/report/:reportValue", element: <SingleReport /> },
    ],
  },
];

function Router() {
  const router = createBrowserRouter(ROUTES);

  return <RouterProvider router={router} />;
}

export default Router;
